"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogFactoryModule = /** @class */ (function () {
    function DialogFactoryModule() {
    }
    return DialogFactoryModule;
}());
exports.DialogFactoryModule = DialogFactoryModule;
